import React, { useState, useEffect } from 'react'
import { AntSelect } from "components/AntComponents";
import { Button } from "antd";
import { Formik } from 'formik';
// import { filterFormSchema } from "./validations";
import {
    cityList,
    worldCities,
    countryList,
    currentStatus,
    investorStatus,
    investorSortValues,
    ticket_size_range,
    investorType,
    priority,
    investorsPreferredChoices,
    whoseContactList
} from 'formFields';

export function InvestorFilterForm({ data, onSubmit, onReset, dynamicFields, columns }) {
    const INITIAL_FORM_DATA = {
        city: null,
        country: null,
        ticket_size_gt: null,
        ticket_size_lt: null,
        industries: null,
        client_segments: null,
        sector: null,
        preferred_stages: null,
        type: null,
        contact_person: null,
        status: null,
        text: null,
        sort: null,
        relationship_manager: null,
        invest_in_countries: null,
        tags: null,
    }
    const [formData, setFormData] = useState(INITIAL_FORM_DATA);

    useEffect(() => {
        if (data) {
            setFormData(data);
        }
    }, [data]);

    const handleSubmit = async (payload) => {
        onSubmit(payload);
    }

    const handleClear = async () => {
        setFormData(INITIAL_FORM_DATA);
        onReset();
    }

    return (
        <Formik
            initialValues={formData}
            enableReinitialize
            // validationSchema={filterFormSchema}
            onSubmit={handleSubmit}
        >
            {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldValue,
            }) => {
                const cityOptions = values.country === "India" ? cityList : (worldCities[values.country] || []);
                return (
                <form onSubmit={handleSubmit} onReset={handleClear}>
                    <div className={`grid grid-cols-${columns} gap-10 mb-2`}>
                        <AntSelect
                            value={values.country}
                            dataSource={countryList}
                            setFieldValue={setFieldValue}
                            fieldName="country"
                            errors={errors}
                            touched={touched}
                            options={{
                                showSearch: true
                            }}
                            onChange={() => setFieldValue('city', null)}
                        />
                        <AntSelect
                            value={values.city}
                            dataSource={cityOptions}
                            setFieldValue={setFieldValue}
                            fieldName="city"
                            errors={errors}
                            touched={touched}
                            options={{
                                showSearch: true
                            }}

                        />
                        <AntSelect
                            value={values.ticket_size_gt}
                            dataSource={ticket_size_range}
                            setFieldValue={setFieldValue}
                            fieldName={"ticket_size_gt"}
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.ticket_size_lt}
                            dataSource={ticket_size_range}
                            setFieldValue={setFieldValue}
                            fieldName={"ticket_size_lt"}
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.industries}
                            dataSource={dynamicFields.industry_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="industries"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.preferred_stages}
                            dataSource={investorsPreferredChoices}
                            setFieldValue={setFieldValue}
                            fieldName="preferred_stages"
                            errors={errors}
                            touched={touched}
                        />
                        {/* <AntSelect
                            value={values.deal_type}
                            dataSource={dealType}
                            setFieldValue={setFieldValue}
                            fieldName="deal_type"
                            errors={errors}
                            touched={touched}
                        /> */}
                        <AntSelect
                            value={values.client_segments}
                            dataSource={dynamicFields.client_segment_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="client_segments"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.sector}
                            dataSource={dynamicFields.sector_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="sector"
                            options={{
                                showSearch: true
                            }}
                        />
                        <AntSelect
                            value={values.type}
                            dataSource={investorType}
                            setFieldValue={setFieldValue}
                            fieldName="type"
                        />
                        <AntSelect
                            value={values.status}
                            dataSource={investorStatus}
                            setFieldValue={setFieldValue}
                            fieldName="status"
                        />
                        <AntSelect
                            value={values.contact_person}
                            dataSource={whoseContactList}
                            setFieldValue={setFieldValue}
                            fieldName="contact_person"
                        />
                        <AntSelect
                            value={values.priority}
                            dataSource={priority}
                            setFieldValue={setFieldValue}
                            fieldName="priority"
                        />
                        <AntSelect
                            value={values.sort}
                            dataSource={investorSortValues}
                            displayExpr={"name"}
                            valueExpr={"value"}
                            setFieldValue={setFieldValue}
                            fieldName="sort"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.relationship_manager}
                            dataSource={dynamicFields.relationship_managers_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="relationship_manager"
                            errors={errors}
                            touched={touched}
                        />
                        <AntSelect
                            value={values.invest_in_countries}
                            dataSource={countryList}
                            setFieldValue={setFieldValue}
                            fieldName="invest_in_countries"
                            errors={errors}
                            touched={touched}
                            options={{
                                showSearch: true
                            }}
                        />
                        <AntSelect
                            value={values.tags}
                            dataSource={dynamicFields.tag_choices || []}
                            setFieldValue={setFieldValue}
                            fieldName="tags"
                            options={{
                                showSearch: true,
                                mode: 'multiple',
                            }}
                        />
                    </div>
                    <div className="flex gap-10">
                        <Button
                            htmlType="submit"
                            className="flex flex-row-reverse"
                        >
                            Apply
                        </Button>
                        <Button
                            danger
                            htmlType="reset"
                            className="flex flex-row-reverse"
                        >
                            Clear
                        </Button>
                    </div>

                </form>
                );
            }}
        </Formik>
    )
}
